/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require ./cell_renderers
//= require ./grid_options
//= require ./boq_utils
//= require ./boq_moves
//= require ./boq_mapping

//= require blueimp-file-upload/js/jquery.fileupload.js

window.BoqTree = {
  _deletedNodes: [],
  _newOrModifiedNodes: [],
  _insertInitItem: false,

  _clearNewOrModifiedNodes() {
    return this._newOrModifiedNodes = [];
  },

  _clearDeletedNodes() {
    return this._deletedNodes = [];
  },

  deleteSelectedRow(row) {
    const confirmation = confirm('Confirm');
    if (confirmation) {
      const selected = row.node;
      if (!selected) { return; }
      this._deletedNodes.push(selected);
      this._newOrModifiedNodes = _.without(this._newOrModifiedNodes, selected);
      this._reGroupFrom(selected, true);
      this._gridOptions.api.applyTransaction({ remove: this._getRowsToDelete(selected) });
      this._gridOptions.api.redrawRows();
      const {
        parent
      } = row.node;
      if (parent && (!parent.allChildrenCount || (parent.allChildrenCount === 0))) {
        if (parent.id === 'ROOT_NODE_ID') {
          this._insertInitialRow();
        } else {
          parent.data["leaf?"] = true;
          this._gridOptions.api.redrawRows({ rowNodes: [parent] });
        }
      }
      return $(document).foundation('dropdown', 'reflow');
    }
  },

  _insertInitialRow() {
    const newRow = this._getEmptyRow();
    newRow.group = [1];
    newRow.groupSortString = '1';
    const transactions = this._gridOptions.api.applyTransaction({ add: [newRow] });
    const newNode = _.last(transactions.add);
    this._newOrModifiedNodes.push(newNode);
    return this._gridOptions.api.redrawRows();
  },

  _insertSibling(row) {
    if (this._gridOptions.api.isAnyFilterPresent()) { return; }
    this._reGroupFrom(row.node);
    this._reSort();
    this._gridOptions.api.refreshClientSideRowModel('group');
    const newRow = this._getEmptyRow();
    newRow.group = _.clone(row.node.data.group);
    newRow.group[newRow.group.length - 1] += 1;
    newRow.groupSortString = newRow.group.join('.');

    const transactions = this._gridOptions.api.applyTransaction({ add: [newRow] });
    const newNode = _.last(transactions.add);
    this._newOrModifiedNodes.push(newNode);
    this._gridOptions.api.redrawRows();
    return $(document).foundation('dropdown', 'reflow');
  },

  _insertChild(row) {
    if (this._gridOptions.api.isAnyFilterPresent()) { return; }
    row.node.setDataValue('unit_price', null);
    this._gridOptions.api.refreshClientSideRowModel('group');
    const newRow = this._getEmptyRow();
    if (row.node.data["leaf?"] === true) {
      row.node.data["leaf?"] = false;
    }
    const children = row.node.childrenAfterGroup;
    newRow.group = row.node.data.group.concat([children.length + 1]);
    newRow.groupSortString = newRow.group.join('.');

    const transactions = this._gridOptions.api.applyTransaction({ add: [newRow] });
    const newNode = _.last(transactions.add);
    this._newOrModifiedNodes.push(newNode);
    this._expandNode(row.node);
    this._gridOptions.api.redrawRows();
    return $(document).foundation('dropdown', 'reflow');
  },

  _insertImage(row) {
    $("#boq-item-photo-form input#photo_node_id").val(row.node.id);
    return $("#boq-item-photo-form input[type='file']").trigger("click");
  },

  _insertNote(row) {
    if (this._gridOptions.api.isAnyFilterPresent()) { return; }
    const newRow = this._getEmptyRow();
    newRow.group = _.clone(row.node.data.group).concat([0]);
    newRow.is_note = true;
    this._gridOptions.api.applyTransaction({ add: [newRow] });
    this._reSort();
    this._expandNode(row.node);
    this._gridOptions.api.redrawRows();
    $(`#note-textarea-${newRow.id}`).focus();
    return $(document).foundation('dropdown', 'reflow');
  },

  _reGroupFrom(node, negative, skipCount) {
    if (negative == null) { negative = false; }
    if (skipCount == null) { skipCount = 0; }
    const diff = negative ? (-1) : 1;

    const children = node.parent.childrenAfterSort;
    const startIndex = children.indexOf(node) + 1;
    const newGroup = _.clone(node.data.group);
    newGroup[newGroup.length - 1] += diff + skipCount;
    return _.each(children.slice(startIndex), child => {
      newGroup[newGroup.length - 1] += 1;
      return this._changeParentGroupWithChildren(child, newGroup);
    });
  },

  _setMovingButtonsVisiblity() {
    const selectedNodes = this._gridOptions.api.getSelectedNodes();
    if ((selectedNodes.length > 0) && selectedNodes[0].selected) {
      const $moveButtonsList = $('#moveLinks');
      $moveButtonsList.find('#up').toggleClass('no', !this._canMoveUp());
      $moveButtonsList.find('#down').toggleClass('no', !this._canMoveDown());
      $moveButtonsList.find('#in').toggleClass('no', !this._canMoveRight());
      return $moveButtonsList.find('#out').toggleClass('no', !this._canMoveLeft());
    } else {
      return $('#moveLinks > a').addClass('no');
    }
  },

  _changeParentGroupWithChildren(row, newGroup, length = null) {
    if (!length) {
      ({
        length
      } = newGroup);
    }
    row.data.group = newGroup.concat(row.data.group.slice(length));
    row.data.groupSortString = row.data.group.join('.');
    row.data['leaf?'] = row.childrenAfterGroup.length === 0;

    return _.each(row.childrenAfterGroup, child => {
      return this._changeParentGroupWithChildren(child, newGroup, length);
    });
  },

  _valueChangedHandler(event) {
    return this._findOrPushModifiedNode(event.node);
  },

  _findOrPushModifiedNode(node) {
    const modifiedNode = _.find(this._newOrModifiedNodes, n => n.data.id === node.data.id);
    if (!modifiedNode) { return this._newOrModifiedNodes.push(node); }
  },

  _showModalWithPhoto(modal, content, event) {
    event.preventDefault();
    const $modal = $(modal);
    const $content = $(content);
    const modalHeader = $content.find('.modal-header > h3');
    modalHeader.text(event.target.attributes.getNamedItem('data-title').value);
    const img = $content.find('img');
    img.attr('src', event.target.attributes.getNamedItem('data-fullimage-url').value);
    $modal.html($content.html());
    $modal.find($content).show();
    return $modal.foundation('reveal', 'open');
  },

  _uploadBoqItemImage() {
    const _this = this;
    return $("#boq-item-photo-form").on('click', function () {
      return $(this).fileupload({
        add(e, data) {
          const node_id = $(this).find('#photo_node_id').val();
          const node = _this._gridOptions.api.getRowNode(node_id);
          node.data.uploading = true;
          _this._gridOptions.api.redrawRows();

          return data.submit();
        },
        done(e, data) {
          const node = _this._gridOptions.api.getRowNode(data.result.node_id);
          node.data.uploading = false;
          node.data.photo_id = data.result.photo_id;
          node.data.photos = [{
            thumbnail_url: data.result.thumbnail_url,
            fullimage_url: data.result.fullimage_url,
            photo_id: data.result.photo_id
          }];
          _this._gridOptions.api.applyTransaction({ update: [node.data] });
          node.setDataValue("photo_id", node.data.photo_id);
          return _this._gridOptions.api.redrawRows();
        },
        fail(e, data) {
          return alert(JSON.parse(data.jqXHR.responseText).details);
        }
      });
    });
  },

  initializeTree(items, editorMode, key, codeColumnsActive) {
    this._boqTree = true;
    agGrid.LicenseManager.setLicenseKey(key);
    suppressLicenseErrorForTestEnvironment();
    this._rawData = items;
    this._editorMode = editorMode ? true : false;
    this._setOptions(codeColumnsActive);
    $(document).on('click', ".boq-image", _.bind(this._showModalWithPhoto, this, '#modalContent', '#boqPhoto'));

    $('#moveLinks').on('click', '#up', () => {
      if (this._canMoveUp()) { return this._moveUp(); }
    });
    $('#moveLinks').on('click', '#down', () => {
      if (this._canMoveDown()) { return this._moveDown(); }
    });
    $('#moveLinks').on('click', '#in', () => {
      if (this._canMoveRight()) { return this._moveRight(); }
    });
    $('#moveLinks').on('click', '#out', () => {
      if (this._canMoveLeft()) { return this._moveLeft(); }
    });

    const gridDiv = document.getElementById('boqTable');
    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;
    if (this._insertInitItem) {
      this._insertInitialRow();
      this._insertInitItem = false;
    }
    this._uploadBoqItemImage();

    $('.ag-header-cell[col-id="ag-Grid-AutoColumn"] .ag-header-cell-text')
      .prepend('<i id="expandAllButton" class="pti pt-minus-square"></i>');

    $('#expandAllButton').on('click', e => {
      return this._expandOrCollapseAll();
    });

    return $(window).resize(_.bind(this._resize, this));
  }
};

if (window.BoqUtils) _.extend(BoqTree, window.BoqUtils);
if (window.CellRenderers) _.extend(BoqTree, window.CellRenderers);
if (window.GridOptions) _.extend(BoqTree, window.GridOptions);
if (window.BoqMoves) _.extend(BoqTree, window.BoqMoves);
if (window.BoqMapping) _.extend(BoqTree, window.BoqMapping);
